<template>
  <div class="layout-main">
    <n-layout-cool :menu="navigation" :profile="profile">
      <template #logo>AdminPanel</template>
      <template #logo-min>AP</template>
      <template #avatar><n-image centered round :src="$app.auth.user().avatar || avatar" /></template>
      <template #name>{{ $app.auth.user() ? $app.auth.user().fullName : '' }}</template>
      <template #company-name>{{ company.title }}</template>
      <div slot="content">
        <page-title />
        <router-view />
      </div>
      <div slot="footer">
      </div>
      <div slot="tools">
        <div></div>
      </div>
    </n-layout-cool>
  </div>
</template>

<script>
import avatar from '../../assets/images/avatar.png'
import PageTitle from '../../components/pageTitle/Index'

export default {
  name: 'MainLayout',
  components: { PageTitle, },
  data: () => ({
    show: false,
    avatar,
    profile: [
      { title: 'Выход', icon: 'sign-out-alt', route: 'login', },
    ],
  }),
  computed: {
    company() {
      return $app.store.getter('app.company')
    },
    navigation() {
      return ($app.auth.user().grants.admin) ? $app.router.navigation([
        { name: 'index', },
        { name: 'categories.list', },
        { name: 'types.list', },
        { name: 'students.list', },
        { name: 'banners.list', },
        { name: 'faqs.list', },
        { name: 'articles.list', },
        { name: 'mainPartners.list', },
        { name: 'partners.list', },
        { name: 'teachers.list', },
        { name: 'certs.list', },
        { name: 'documents.list', },
        { name: 'content', },
        { name: 'images.list', },
        { name: 'pages.list', },
        { name: 'accounts.list', },
        { name: 'pays.list', },
        { name: 'users.list', },
      ]) : $app.router.navigation([
        { name: 'index', },
        { name: 'categories.list', },
        { name: 'types.list', },
        { name: 'students.list', },
        { name: 'banners.list', },
        { name: 'faqs.list', },
        { name: 'articles.list', },
        { name: 'mainPartners.list', },
        { name: 'partners.list', },
        { name: 'teachers.list', },
        { name: 'certs.list', },
        { name: 'documents.list', },
        { name: 'accounts.list', },
        { name: 'pays.list', },
      ])
    },
  },
  watch: {
    '$store.state.auth.user'() {
      this.checkAuth()
    },
  },
  created() {
    this.checkAuth()
  },
  methods: {
    checkAuth() {
      if (!$app.auth.user()) {
        this.$router.push({ name: 'login', })
        return false
      }
      return true
    },
  },
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Ubuntu:100,100i,300,300i,400,400i,500,500i,700,700i,900,900i');
  @import '../../../node_modules/nast-ui/src/style/global';
  
  @include initialize((
    default: (
      colors: (
        primary: #0093dd,
        secondary: #ffd200,
        tertiary: #c556ff,
      ),
      typography: (
        header-font: 'Ubuntu, sans-serif',
        text-font: '400 1em Ubuntu, sans-serif',
        h1-font: '300 2em var(--header-font)',
        h3-font: '400 1.2em var(--header-font)',
        text-color: #444,
      ),
    ),
  ));
  
  .layout-main {
    .n-layout-cool {
      .n-aside {
        .n-logo-full > .n-logo {
          padding: 5px 0 3px;
        }
      }
    }
    
    .container {
      padding: 10px;
    }
  }
  
  .sub {
    font-size: .9em;
    opacity: .9;
  }
  
  .table-tools {
    margin-bottom: 10px;
  }
</style>
